import CancelIcon from '@mui/icons-material/Cancel'
import CheckIcon from '@mui/icons-material/Check'
import EditIcon from '@mui/icons-material/Edit'
import { Alert, AlertTitle, Box, IconButton, Stack, StackProps, TextField, Typography } from '@mui/material'
import { useState } from 'react'
import { useMutation } from 'urql'
import { graphql } from '../gql'
import { ProjectPageQuery } from '../gql/graphql'

const updateProjectMutation = graphql(/* GraphQL */ `
  mutation ProjectDetailsHeaderUpdateProject($updateProjectId: Int!, $input: UpdateProjectInput!) {
    UpdateProject(id: $updateProjectId, input: $input) {
      id
    }
  }
`)

type Props = {
  proj: ProjectPageQuery['Project']
  stackProps?: StackProps
}
export default function ProjectDetailsHeader(props: Props) {
  const { proj, stackProps = {} } = props
  const [isEditing, setIsEditing] = useState(false)
  // const [newName, setNewName] = useState(proj.name)
  const [updateProjectResult, updateProject] = useMutation(updateProjectMutation)

  const handleEditSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    try {
      const data = new FormData(e.currentTarget)
      const projectName = data.get('projectName')
      if (typeof projectName !== 'string') {
        throw new Error('Project name is required')
      }
      const trimmedProjectName = projectName.trim()
      if (trimmedProjectName === proj.name) {
        throw new Error('Project name is the same')
      }
      await updateProject({ updateProjectId: proj.id, input: { name: trimmedProjectName } })
      setIsEditing(false)
    } catch (error) {
      console.warn('Aborting project name update')
      setIsEditing(false)
      return
    }
  }
  const handleCancelEdit = () => {
    setIsEditing(false)
  }
  return (
    <Stack direction="column" {...stackProps}>
      <Typography>Project Details</Typography>
      {updateProjectResult.error ? (
        <Alert severity="error">
          <AlertTitle>Error updating project name</AlertTitle>
          {updateProjectResult.error.message}
        </Alert>
      ) : isEditing ? (
        <form onSubmit={handleEditSubmit} onReset={handleCancelEdit}>
          <Box display="flex" alignItems="baseline" justifyContent="flex-start">
            <TextField
              name="projectName"
              defaultValue={proj.name}
              disabled={updateProjectResult.fetching}
              onKeyDown={(e) => {
                if (e.key === 'Escape') {
                  handleCancelEdit()
                }
              }}
            />
            <IconButton aria-label="save project name" type="submit" size="small" color="success">
              <CheckIcon color="inherit" />
            </IconButton>
            <IconButton type="reset" aria-label="cancel edit project name" onClick={handleCancelEdit} size="small">
              <CancelIcon color="inherit" />
            </IconButton>
          </Box>
        </form>
      ) : (
        <Box display="flex" alignItems="baseline" justifyContent="flex-start">
          <Typography variant="h1" style={{ marginTop: -4 }}>
            {proj.name}
          </Typography>
          <IconButton aria-label="edit project name" onClick={() => setIsEditing(true)} size="small" color="info">
            <EditIcon color="inherit" />
          </IconButton>
        </Box>
      )}
    </Stack>
  )
}
